/*
 * Module for the Benefit Payroll Insurance Deduction Register criteria page
 */
rs.module("content/reports/criteria/benefitpayrollinsurancedeductionregistercriteria",

    ["controls/data/grid", "common/select-helper"],

    function (gridModule, selectHelper) {

        function initialize(lrsGridApi, jsSelectors, ajaxUrls, compositeMonthYearColumnID) {
            var filter = $.js(jsSelectors.filter);
            var includeManualCheckBox = filter.js(jsSelectors.includeManualCheckBox);
            var includeLumpSumsCheckBox = filter.js(jsSelectors.includeLumpSumsCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            includeManualCheckBox.change(filterCheckBoxChanged);
            includeLumpSumsCheckBox.change(filterCheckBoxChanged);

            // Refresh the grid based on checkbox selection
            function filterCheckBoxChanged() {
                loadingSpinner.show();
                gridModule.update(
                    ajaxUrls.refreshGridUrl,

                    { includeManualPayroll: includeManualCheckBox.is(':checked'), includeLumpSums: includeLumpSumsCheckBox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }

            var payrollProcessingMonthYearHidden = $.js(jsSelectors.payrollProcessingMonthYearHidden);

            // Populate the hidden field with the Payroll Period of the selected row
            lrsGridApi.selectionChanged(function (values, rows) {
                if (values.length > 0) {
                    var compositeMonthYear = rows[0][compositeMonthYearColumnID];
                    payrollProcessingMonthYearHidden.val(compositeMonthYear);
                } else {
                    payrollProcessingMonthYearHidden.val('');
                }
            });

            var insuranceTypeSelect = $.js(jsSelectors.insuranceTypeSelect);
            var insuranceCarriersMultiSelect = $.js(jsSelectors.insuranceCarriersMultiSelect);
            var insuranceCarriersMultiSelectHelper = selectHelper.getHelper(insuranceCarriersMultiSelect);

            // Clear validation by adding a carrier (as some types do not have carriers) and selecting it.
            // If no type selected, disable the carriers. 
            // Populate the carriers with the new selected type.
            insuranceTypeSelect.change(function () {
                insuranceCarriersMultiSelectHelper
                    .appendOptions([{ text: '', value: '' }])
                    .setValue('')
                    .setDisabled(this.value == '')
                    .loadOptionsFrom(ajaxUrls.updateCarriersUrl, { insuranceType: this.value });

                insuranceCarriersMultiSelect.clearErrors();
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);